import React from 'react';
import MaterialIconButton from '@material-ui/core/IconButton';

const IconButton = props => <MaterialIconButton color={props.type} {...props} />;

export default IconButton;
